// extracted by mini-css-extract-plugin
export default {"mark":"mark---pJ_Fi","version-wrapped":"version-wrapped---ekqYM","version-row-formatted":"version-row-formatted---Rd3mp"};